import { graphql } from "@/lib/gql/__generated__";

export const MagazineAnalyticsSettingUpdate_DesignPage_Mutation = graphql(`
	mutation MagazineAnalyticsSettingUpdate_DesignPage(
		$input: MagazineAnalyticsSettingInput!
		$guestPageVisibilitySettingsInput: GuestPageVisibilitySettingsInput!
		$shouldUpdateGuestPageVisibility: Boolean!
	) {
		magazineAnalyticsSettingUpdate(input: $input) {
			userErrors
			magazineAnalyticsSetting {
				id
				hotelID
				gtmAvailable
				gtmID
				pixelAvailable
				pixelID
			}
		}
		# 画面のページの公開状態を変えたときだけ実行する（toGuestPageVisibilitySettingsVariables を参照）
		guestPageVisibilitySettingsUpdate(input: $guestPageVisibilitySettingsInput)
			@include(if: $shouldUpdateGuestPageVisibility) {
			userErrors
			guestPageVisibilitySettings {
				id
				hotelID
				plainVisibility
				magazineVisibility
				snackVisibility
			}
		}
	}
`);
